import type React from 'react';
import { t } from 'i18next';

interface MyPageSubTitleProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
}

const MyPageSubTitle = ({ icon, title , description}: MyPageSubTitleProps) => {
  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center gap-[4px]">
        {icon}
        <h2 className="text-main-light-2 dark:text-main-dark-2 text-[15px] font-bold leading-normal min-w-[100px]">
          {t(title)}
        </h2>
      </div>
      {description && (
        <p className="text-sub-light-1 dark:text-sub-dark-1 text-[11px] leading-normal text-right">
          {t(description)}
        </p>
      )}
    </div>
  );
}

export default MyPageSubTitle